import React, { useState } from 'react';
import { BookOpen, Menu, Search, ShoppingBag, Sparkles, X } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { COPY } from '../../constants/elegantContent';
import '../../styles/home-elegant.css';

const categoryLinks = [
  { label: 'Libros', path: '/books' },
  { label: 'Manga', path: '/manga' },
  { label: 'Comics', path: '/comics' }
];

const ElegantNavbar = ({ onNavigateSection, transparent = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { itemCount } = useCart();
  const { language, changeLanguage } = useLanguage();
  const copy = COPY[language];

  const handleLanguageChange = (lang) => {
    if (lang !== language) changeLanguage(lang);
  };

  const handleNavClick = (target) => {
    if (typeof onNavigateSection === 'function' && location.pathname === '/home') {
      onNavigateSection(target);
    } else {
      navigate(target === 'inicio' ? '/home' : `/home#${target}`);
    }
    setMobileMenuOpen(false);
  };

  const handleCartNavigate = () => {
    navigate('/cart');
    setMobileMenuOpen(false);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    if (search.trim()) {
      navigate(`/books?q=${encodeURIComponent(search.trim())}`);
      setMobileMenuOpen(false);
    }
  };

  return (
    <>
      <header className={`rdp-nav ${transparent ? 'is-transparent' : 'is-scrolled'}`}>
        <div className="rdp-nav-container">
          <button type="button" className="rdp-brand" onClick={() => navigate('/home')}>
            <BookOpen size={28} className="rdp-brand-icon" />
            <div className="rdp-brand__text">
              <span className="rdp-brand__name">Relatos de Papel</span>
              <span className="rdp-brand__tagline">{copy.brandTagline}</span>
            </div>
          </button>

          <nav className="rdp-nav-links">
            <button type="button" onClick={() => handleNavClick('inicio')}>Inicio</button>
            <button type="button" onClick={() => handleNavClick('catalogo')}>Catálogo</button>
            {categoryLinks.map((link) => (
              <button key={link.path} type="button" onClick={() => navigate(link.path)}>
                {link.label}
              </button>
            ))}
          </nav>

          <div className="rdp-nav-actions">
            <form className="rdp-search-mini" onSubmit={handleSearch}>
              <Search size={16} />
              <input
                type="search"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder="Buscar títulos..."
              />
            </form>

            <div className="rdp-nav-btns-group">
              <div className="rdp-language-switch">
                <button
                  type="button"
                  className={`rdp-lang-btn ${language === 'es' ? 'is-active' : ''}`}
                  onClick={() => handleLanguageChange('es')}
                >
                  ES
                </button>
                <div className="rdp-divider" />
                <button
                  type="button"
                  className={`rdp-lang-btn ${language === 'en' ? 'is-active' : ''}`}
                  onClick={() => handleLanguageChange('en')}
                >
                  EN
                </button>
              </div>

              <button type="button" className="rdp-cart-icon-btn" onClick={handleCartNavigate}>
                <ShoppingBag size={22} />
                {itemCount > 0 && <span className="rdp-cart-badge">{itemCount}</span>}
              </button>

              <button
                type="button"
                className="rdp-mobile-toggle"
                onClick={() => setMobileMenuOpen((v) => !v)}
              >
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>
      </header>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.nav
            className="rdp-mobile-menu"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <button onClick={() => handleNavClick('inicio')}>Inicio</button>
            <button onClick={() => handleNavClick('catalogo')}>Catálogo</button>
            {categoryLinks.map((link) => (
              <button key={link.path} onClick={() => navigate(link.path)}>{link.label}</button>
            ))}
            <button onClick={handleCartNavigate}>Carrito ({itemCount})</button>
          </motion.nav>
        )}
      </AnimatePresence>
    </>
  );
};

export default ElegantNavbar;
